import {FloorChoice} from "../../real_estate/types/FloorChoice";

//  Below floor choices are considered "friendly" because they're only valid values for the "static url"
export const friendlyFloorChoices = [FloorChoice.GROUND, FloorChoice.GROUND_WITH_GARDEN, FloorChoice.LAST_LEVEL];
